import React, { Fragment } from "react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
} from "@material-ui/core";
import { palette } from "configurations/styles/theme";
import usePaymentsMethods, {
  BootstrapInput,
} from "hooks/useInformationPaymentsMethods";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

const MultiplePayments = ({
  informacionPagos,
  setInformacionPagos,
  viewPago,
  setViewPago,
  totals,
}) => {
  //para la fecha
  const dateToday = new Date();
  const minDate = new Date();
  const maxDate = new Date();
  const {
    setPago,
    classes,
    classesApp,
    classesGlobal,
    open,
    pago,
    empty,
    handleClickOpen,
    handleClose,
    hadleAddPago,
    handleChange,
    handleChangeUniversal,
    fecVencimiento,
    setFecVencimiento,
    handleChangeTotal,
    summation,
  } = usePaymentsMethods(
    informacionPagos,
    setInformacionPagos,
    viewPago,
    setViewPago,
    totals
  );

  return (
    <Fragment>
      <Grid container justify="center" className={classes.divButton}>
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          Agregar Información de Pago a Plazo
        </Button>
      </Grid>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">Nueva cuota </DialogTitle>
        <DialogContent>
          <form>
            <Grid container>
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {/* <Grid item xs={12} md={12} className={classes.divForm}>
                                <label> <strong>Pago faltante: <font color={palette.info.main}> {`${summation()}`}</font></strong></label>
                            </Grid> */}

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Fecha de vencimiento de la cuota:{" "}
                  <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                  <DatePicker
                    className={
                      fecVencimiento
                        ? fecVencimiento
                          ? "form-control is-valid"
                          : "form-control"
                        : "form-control"
                    }
                    disableToolbar
                    disablePast
                    variant="dialog"
                    inputVariant="outlined"
                    cancelLabel="Cancelar"
                    okLabel="Seleccionar"
                    format="yyyy-MM-dd'T'HH:mm:ssXXX"
                    margin="normal"
                    name="fecVencimiento"
                    value={fecVencimiento}
                    onChange={setFecVencimiento}
                  />
                </MuiPickersUtilsProvider>
                {empty.fechaVencimiento != null && (
                  <p className={classesApp.errorLetters}>
                    {empty.fechaVencimiento}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>
                  Valor de la cuota: <font color={palette.error.main}>*</font>
                </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  placeholder="Ej. 300"
                  name="valorCuota"
                  value={pago.valorCuota}
                  onChange={handleChangeTotal}
                  autoComplete="off"
                  className={
                    pago
                      ? pago.valorCuota
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />

                {empty.valorCuota != null && (
                  <p className={classesApp.errorLetters}>{empty.valorCuota}</p>
                )}
              </Grid>
              <Grid item xs={12} md={4} className={classes.divForm}>
                <label>Información: </label>
              </Grid>
              <Grid item xs={12} md={8} className={classes.divInput}>
                <input
                  type="text"
                  name="informacionInteres"
                  value={pago.informacionInteres}
                  onChange={handleChangeUniversal}
                  autoComplete="off"
                  className={
                    pago
                      ? pago.informacionInteres
                        ? "form-control is-valid"
                        : "form-control"
                      : "form-control"
                  }
                />
                {empty.informacionInteres != null && (
                  <p className={classesApp.errorLetters}>{empty.informacionInteres}</p>
                )}
              </Grid>

              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider />
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={hadleAddPago}
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default MultiplePayments;
